import { PAYMENT_METHODS } from '../../constants';

import { getImagesFolderPath } from '../utils/getExternalImagePath';
import LazyLoad from '../LazyLoad';

import './PaymentMethods.scss';

const PaymentMethods = () => (
  <LazyLoad offset={100} once as="span" className="payment-methods">
    {PAYMENT_METHODS.map(({ filename, name }) => (
      <img key={name} src={getImagesFolderPath(filename)} alt={name} />
    ))}
  </LazyLoad>
);

export default PaymentMethods;
